import useActivePlan from './useActivePlan';
import { isPremiumPlan } from 'Containers/Scheduler/containers/CalendarHeader/utils/getActivePlan';

/**
 * Piano Premium attivo per il salone corrente (stessa logica della fatturazione).
 * Base → false.
 */
export default function useIsPremiumUnlocked() {
  const plan = useActivePlan();
  return isPremiumPlan(plan);
}
